import { makeStyles } from "@material-ui/core/styles";

export const quickwinsStyles = makeStyles(() => ({
  mentorTip: {
    marginBottom: "20px",
    "& .header .MuiTypography-root": {
      fontWeight: 400,
      "& b": {
        fontWeight: 700,
      },
    },
  },
  clickableItem: {
    cursor: "pointer",
  },
}));
